/*
 *   File : calendar.js
 *   Author : https://evoqins.com
 *   Description : date picker component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import { format } from 'date-fns';

//custom style
import style from "../../Style/Component/input.module.scss";

//Custom components
import { OverLay } from '../Others';
import { Icon } from '../Icon';

const CustomDatePicker = (props) => {

    const [selectedDate, setSelectedDate] = useState(null);

    const default_month = new Date();

    useEffect(() => {
        if (props.selected !== null) {
            setSelectedDate(new Date(props.selected));
        } else {
            setSelectedDate(props.selected);

        }
    }, [props.selected]);


    // Function to disable future days
    const _handleDisableFutureDays = (day) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        day.setHours(0, 0, 0, 0);
        return day.getTime() > today.getTime();
    };

    const _handleDisablePastDays = (day) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return day.getTime() < today.getTime(); // Disables past dates
    };

    const _handleDisableBeforeMinDate = (day) => {
        if (!day) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        day.setHours(0, 0, 0, 0);

        // Disable future days
        if (day.getTime() > today.getTime()) {
            return true;
        }

        // Disable days before minDate
        if (props.minDate) {
            const min = new Date(props.minDate);
            min.setHours(0, 0, 0, 0);
            return day.getTime() < min.getTime();
        }

        return false;
    };

    const _handleDisableStartDate = (day) => {
        if (!day) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        day.setHours(0, 0, 0, 0);

        if (day.getTime() > today.getTime()) return true;

        if (props.maxDate) {
            const max = new Date(props.maxDate);
            max.setHours(0, 0, 0, 0);
            return day.getTime() > max.getTime();
        }

        return false;
    };


    return (
        <div className={props.wrapperClass}>
            {props.label &&
                <label className={`${props.labelStyle} d-flex e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </label>
            }

            <div className={`position-relative ${props.type === 2 && props.width ? props.width : 'w-240px'}`}>
                {props.type === 2 ?

                    <div className={`${props.toggle ? 'e-border-0-5px-blue-violet' : props.error ? 'e-border-0-5px-carmine-pink' : 'e-border-1px-light-purple'}  e-bg-white padding-10px-tb padding-16px-lr  d-flex justify-content-between border-radius-8 cursor-pointer`}
                        onClick={props.handleToggle}>
                        {selectedDate !== null ?
                            <>
                                <p className='mb-0 e-primary-font e-font-14 e-text-chinese-black e-font-weight-500 line-height-18px'>
                                    {format(selectedDate, 'dd-MM-yyyy')}
                                </p>
                                <div onClick={(event) => event.stopPropagation()}>
                                    <Icon icon="close"
                                        className='cursor-pointer d-flex position-relative '
                                        size="16px"
                                        onClick={props.handleClear} />
                                </div>
                            </>
                            :
                            <>
                                <p className='mb-0 e-text-quick-silver e-primary-font e-font-14 e-font-weight-500 line-height-18px'>
                                    {props.placeholder}
                                </p>
                                <img src={require("../../Assets/Image/Others/calendar.svg").default} />
                            </>
                        }
                    </div>
                    :
                    <div className={`${props.toggle ? 'e-border-0-5px-blue-violet' : props.error ? 'e-border-0-5px-carmine-pink' : 'e-border-0-5px-arsenic'} p-3 d-flex justify-content-between border-radius-8 cursor-pointer`}
                        onClick={props.handleToggle}>
                        {selectedDate !== null ?
                            <>
                                <p className='mb-0 e-primary-font e-font-14 e-text-chinese-black e-font-weight-500 line-height-18px'>
                                    {format(selectedDate, 'dd-MM-yyyy')}
                                </p>
                                <div onClick={(event) => event.stopPropagation()}>
                                    <Icon icon="close"
                                        className='cursor-pointer d-flex position-relative '
                                        size="16px"
                                        onClick={props.handleClear} />
                                </div>
                            </>
                            :
                            <>
                                <p className='mb-0 e-text-davys-grey-light e-primary-font e-font-14 e-font-weight-500 line-height-18px'>
                                    {props.placeholder}
                                </p>
                                <img src={require("../../Assets/Image/Others/calendar.svg").default} />
                            </>
                        }
                    </div>}

                {props.error &&
                    <p className={`${style.e_error_message} position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }

                {/* Date picker */}
                {props.toggle &&
                    <>
                        <OverLay isOpen={props.toggle} onClose={props.handleClose} />
                        <DayPicker mode="single"
                            selected={selectedDate}
                            showOutsideDays
                            className={`${props.className} position-absolute top-54px e-day-picker w-358px e-bg-white border-radius-16 z-index-99`}
                            format="yyyy-MM-dd"
                            defaultMonth={default_month}
                            // fromMonth={default_month}
                            disabled={(day) => {
                                if (props.allowAllDates === true) {
                                    return false;
                                }
                                if (props.minDate) {
                                    return _handleDisableBeforeMinDate(day); // disables before startDate
                                } else if (props.maxDate) {
                                    return _handleDisableStartDate(day);
                                }
                                return props.future === true
                                    ? _handleDisablePastDays(day)
                                    : _handleDisableFutureDays(day);
                            }}
                            selectedDays={props.selected}
                            onDayClick={props.onDayClick}
                            onSelect={props.handleSelect} />
                    </>
                }
            </div>

        </div >

    )
}

export default memo(CustomDatePicker);